import { render, staticRenderFns } from "./MetricModal.vue?vue&type=template&id=6c2be0b2&"
import script from "./MetricModal.vue?vue&type=script&lang=js&"
export * from "./MetricModal.vue?vue&type=script&lang=js&"
import style0 from "./MetricModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports